import styled from 'styled-components';

type Props = {
  step: string;
};

const Step = ({ step }: Props) => {
  return <Wrapper>{step}</Wrapper>;
};
export default Step;

const Wrapper = styled.span`
  padding: 4px 16px;
  gap: 10px;
  border-radius: 100px;
  width: fit-content;
  background: var(--KTP-Grayscale-Gray_12, #333);
  color: var(--KTP-Grayscale-Gray_03, #f4f4f4);
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;
